import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { BsEye, BsTrash } from "react-icons/bs";
import Nav from "../../../Components/base/nav";
import RichTextEditor from "../../../Components/RichTextEditor"; // Ensure this import is correct
import ChooseImage from "../../../Components/Modal/ChooseImage";
import ActionBar from "../../../Components/Button/ActionBar";
import ContentForm from "../../../Components/Forms/ShowForm";
import ShowSEOForm from "../../../Components/Forms/ShowSEOForm";
import StoryDetails from "../../../Components/Forms/StoryDetails";
import Sidebar from "../../../Components/base/sidebar";
import Delete from "../../../Components/Button/Delete";
import { toast } from 'sonner';

export default function ShortStory() {
  const location = useLocation();
  const id = location.state && location.state.id;
  const [banner_image, setBannerImage] = useState<File | null>(null);
  const [poster_image, setPosterImage] = useState<File | null>(null);
  const [thumbnail_image, setThumbnailImage] = useState<File | null>(null);
  const [is_SoldOut, setIs_SoldOut] = useState<boolean>(false);
  const [ticket_group_code, setTicketGroupCode] = useState("");
  const [post_date, setPostDate] = useState<any | null>(null);
  const [buy_date, setBuyDate] = useState<any | null>(null);
  const [due_date, setDueDate] = useState<any | null>(null);
  const [event_date_start, setEventDateStart] = useState<any | null>(null);
  const [event_date_end, setEventDateEnd] = useState<any | null>(null);
  const [event_time_start, setEventTimeStart] = useState<any | null>(null);
  const [event_time_end, setEventTimeEnd] = useState<any | null>(null);
  const [title, setTitle] = useState("");
  const [venue, setVenue] = useState("");
  const [body, setBody] = useState("");
  const [slug, setSlug] = useState("");
  const [url, setUrl] = useState("");
  const [seo_title, setSeo_Title] = useState("");
  const [seo_details, setSeo_Details] = useState("");
  const [item, setItem] = useState<any | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [role, setRole] = useState<string | null>(null);
  const [banner_image_name, setBannerImageName] = useState<string>("");
  const [poster_image_name, setPosterImageName] = useState<string>("");
  const [thumbnail_image_name, setThumbnailImageName] = useState<string>("");
  useEffect(() => {
    if (id) {
      fetchItem(id);
    }
  }, [id]);

  const isValidTextFormat = (format: string) => /^[A-Za-z0-9-]+$/.test(format);

  const handleTicketGroupCodeChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTicketGroupCode(e.target.value);
  };

  const handlePostDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPostDate(e.target.value);
  };

  const handleisSoldOutChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIs_SoldOut(e.target.checked);
  };

  const handleBuyDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBuyDate(e.target.value);
  };

  const handleDueDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDueDate(e.target.value);
  };

  const handleEventDateStartChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setEventDateStart(e.target.value);
  };

  const handleEventDateEndChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEventDateEnd(e.target.value);
  };

  const handleEventTimeStartChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setEventTimeStart(e.target.value);
  };

  const handleEventTimeEndChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEventTimeEnd(e.target.value);
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };

  const handleVenueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setVenue(e.target.value);
  };

  const handleBodyChange = (content: string) => {
    setBody(content);
  };

  const handleSlugChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;

    if (isValidTextFormat(newName) || newName === "") {
      setSlug(newName);
    }
  };

  const handleSeoTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSeo_Title(e.target.value);
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSeo_Details(e.target.value);
  };

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUrl(e.target.value);
  };

  const handleBannerImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setBannerImage(e.target.files[0]);
    }
  };

  const handlePosterImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setPosterImage(e.target.files[0]);
    }
  };

  const handleThumbnailImageChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (e.target.files && e.target.files.length > 0) {
      setThumbnailImage(e.target.files[0]);
    }
  };

  const navigate = useNavigate();

  const fetchItem = async (id: number) => {
    try {
      const response = await axios.get(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/show/${id}`
      ); // Fetch item based on ID
      const show = response.data.Show;
      const ticketgroupcode = response.data.Ticket_Code;
      if (show) {
        const {
          post_date,
          buy_date,
          due_date,
          event_date_start,
          event_date_end,
          event_time_end,
          event_time_start,
          title,
          venue,
          body,
          slug,
          url,
          seo_title,
          seo_details,
          is_SoldOut,
          banner_image,
          thumbnail_image,
          poster_image,
        } = show;
        setPostDate(post_date);
        setBuyDate(buy_date);
        setDueDate(due_date);
        setEventDateStart(event_date_start);
        setEventDateEnd(event_date_end);
        setEventTimeStart(event_time_start);
        setEventTimeEnd(event_time_end);
        setTitle(title);
        setVenue(venue);
        setBody(body);
        setSlug(slug);
        setUrl(url);
        setSeo_Title(seo_title);
        setSeo_Details(seo_details);
        setIs_SoldOut(is_SoldOut);
        setBannerImageName(banner_image);
        setPosterImageName(poster_image);
        setThumbnailImageName(thumbnail_image);
      }
      if (ticketgroupcode) {
        const { ticket_group_code } = ticketgroupcode;
        setTicketGroupCode(ticket_group_code);
      }
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("ticket_group_code", ticket_group_code);
    formData.append("post_date", post_date);
    formData.append("buy_date", buy_date);
    formData.append("due_date", due_date);
    formData.append("event_date_start", event_date_start);
    formData.append("event_date_end", event_date_end);
    formData.append("event_time_start", event_time_start);
    formData.append("event_time_end", event_time_end);
    formData.append("title", title);
    formData.append("venue", venue);
    formData.append("body", body);
    formData.append("slug", slug);
    formData.append("url", url);
    formData.append("seo_title", seo_title);
    formData.append("seo_details", seo_details);
    formData.append("is_SoldOut", is_SoldOut ? "1" : "0");
    if (banner_image) {
      formData.append("banner_image", banner_image);
    }
    if (poster_image) {
      formData.append("poster_image", poster_image);
    }
    if (thumbnail_image) {
      formData.append("thumbnail_image", thumbnail_image);
    }

    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        // Handle the case where authToken is not available
        alert("Authentication token not found!");
        setIsSubmitting(false);
        return;
      }

      await axios.post(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/show/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      toast.success(<p className="text-[16px]">Content was submitted successfully!</p>, {
        duration: 1500,
      });
      setTimeout(() => {
        navigate("/view/post/Show");
      }, 1600);
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      alert(`There was an error submitting the form!, ${error}`);
      // Handle error (e.g., show an error message)
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 3000);
    }
  };

  // const handleSaveDraft = async (e: React.FormEvent) => {
  //     e.preventDefault();
  //     setIsSaved(true);

  //     const formData = new FormData();
  //     formData.append('category', category);
  //     formData.append('sub_category', sub_category);
  //     formData.append('title', title);
  //     formData.append('body', body);
  //     formData.append('seo_title', seo_title);
  //     formData.append('description', description);
  //     formData.append('sub_head', sub_head);
  //     formData.append('photo_by', photo_by);
  //     if (image) {
  //         formData.append('image', image);
  //     }

  //     try {
  //         const authToken = localStorage.getItem('authToken');
  //         if (!authToken) {
  //             // Handle the case where authToken is not available
  //             alert('Authentication token not found!');
  //             setIsSubmitting(false);
  //             return;
  //         }

  //         await axios.post(`https://cdn.pulp.ph/api/v1/shortStory/save/${id}`, formData, {
  //             headers: {
  //                 'Content-Type': 'multipart/form-data',
  //                 Authorization: `Bearer ${authToken}`,
  //             }
  //         });
  //         alert('Draft Saved Successfully !!'); // Handle success (e.g., show a success message or redirect)
  //         navigate('/view/post/Show');
  //     } catch (error) {
  //         console.error('There was an error submitting the form!', error);
  //         alert(`There was an error submitting the form!, ${error}`);
  //         // Handle error (e.g., show an error message)
  //     } finally {
  //         setTimeout(() => {
  //             setIsSaved(false);
  //         }, 3000);
  //     }
  // };

  const handleDelete = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        alert("Authentication token not found!");
        return;
      }

      const confirmDelete = window.confirm(
        "Are you sure you want to delete this content?"
      );
      if (!confirmDelete) {
        return; // If user cancels, do nothing
      }

      if (id) {
        await axios.delete(
          `https://cdn.pulp.ph/api/v1/pulpliveworld/show/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
      }
      alert("Content Deleted Successfully !!");
      navigate("/view/post/Show");
    } catch (error) {
      console.error("There was an error deleting the content!", error);
      alert(`There was an error deleting the content!, ${error}`);
    }
  };

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    setRole(storedRole);
  }, []);

  const handleViewShortstory = () => {
    window.open(`https://pulpmagazine.com/article/${id}`, "_blank");
  };

  return (
    <>
      <div className="w-full p-5">
        <div className="flex justify-between items-center mb-4">
          <h1 className="GraphikSemibold text-[20px] font-semibold">Edit Show</h1>
          <ActionBar
            role={role}
            onSubmit={handleSubmit}
            onView={handleViewShortstory}
            isSubmitting={isSubmitting}
            isSaved={isSubmitting}
          />
        </div>

        <div className="py-5 px-4 rounded bg-white">
          <ContentForm
            ticket_group_code={ticket_group_code}
            post_date={post_date}
            buy_date={buy_date}
            due_date={due_date}
            event_date_start={event_date_start}
            event_date_end={event_date_end}
            event_time_start={event_time_start}
            event_time_end={event_time_end}
            title={title}
            venue={venue}
            body={body}
            url={url}
            banner_image_name={banner_image_name}
            banner_image={banner_image}
            poster_image_name={poster_image_name}
            poster_image={poster_image}
            thumbnail_image_name={thumbnail_image_name}
            thumbnail_image={thumbnail_image}
            is_SoldOut={is_SoldOut}
            onSoldOutChange={handleisSoldOutChange}
            onTicketGroupCodeChange={handleTicketGroupCodeChange}
            onPostDateChange={handlePostDateChange}
            onBuyDateChange={handleBuyDateChange}
            onDueDateChange={handleDueDateChange}
            onEventDateStartChange={handleEventDateStartChange}
            onEventDateEndChange={handleEventDateEndChange}
            onEventTimeStartChange={handleEventTimeStartChange}
            onEventTimeEndChange={handleEventTimeEndChange}
            onTitleChange={handleTitleChange}
            onVenueChange={handleVenueChange}
            onBodyChange={handleBodyChange}
            onUrlChange={handleUrlChange}
            onBannerImageChange={handleBannerImageChange}
            onPosterImageChange={handlePosterImageChange}
            onThumbnailImageChange={handleThumbnailImageChange}
          />

          {(role === "IT" || role === "Live") && (
            <ShowSEOForm
              seo_title={seo_title}
              seo_details={seo_details}
              slug={slug}
              onSeoTitleChange={handleSeoTitleChange}
              onDescriptionChange={handleDescriptionChange}
              onSlugChange={handleSlugChange}
            />
          )}

          {/* <div className="w-full border-1 border-black rounded mb-5"> </div>
          <StoryDetails />
          <Delete onDelete={handleDelete} /> */}
        </div>
      </div>
    </>
  );
}
